import { axiosV3 } from "../../../Utils/Axios/axiosV3";

export const getTicketSubjectsService = async (userToken: string) => {
  return axiosV3.get("/user/ticket-subject", {
    headers: {
      Authorization: `Bearer ${userToken}`,
    },
  });
};
